<div class="col-md-6">
  <mat-label>{{singleDropdownData.title}}</mat-label>
  <ng-select (change)="chosenOptions()" [(ngModel)]="selectedValues">
      <ng-option *ngFor="let item of singleDropdownData.values" [value]="item">{{item}}</ng-option>
  </ng-select>
</div>
